import Api from "./Api";

class ImageApi extends Api {
  static list(params={}) {
    // sort=popular&limit=4&page=1&after=&indexes=sidebar&display_tags=0
    return this.get("image", {
      sort: "popular",
      page: 1,
      limit: 10,
      ...params
    });
  }

  static details(slug, params={}) {
    return this.get(`image/${slug}`, params);
  }

  static pagination(type, slug, params={}) {
    return this.get(`${type}/${slug}/pagination`, params);
  }
}

export default ImageApi;